'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Button = require('../../../../components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Translate = require('../../../../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewTab = function NewTab(_ref) {
  var url = _ref.url;

  return _react2.default.createElement(
    'div',
    { className: 'NewTab' },
    _react2.default.createElement(_Translate2.default, {
      tagName: 'p',
      id: 'label.new-tab',
      defaultMessage: 'A new tab is required in order to proceed, please press the button to continue...'
    }),
    _react2.default.createElement(
      _Button2.default,
      {
        className: 'primary',
        onClick: function onClick() {
          window.open(url, '_blank');
        } },
      _react2.default.createElement(_Translate2.default, { id: 'action.open-tab', defaultMessage: 'Open new tab' })
    )
  );
};

exports.default = NewTab;